// src/components/ScrollSection.js
import React from 'react';

const logos = [
  { src: '/images/logos/macys.png.webp', alt: 'Macys' },
  { src: '/images/logos/calvinklein.png.webp', alt: 'calvinklein' },
  { src: '/images/logos/tommyhilfiger.png.webp', alt: 'tommyhilfiger' },
  { src: '/images/logos/nike.png.webp', alt: 'Nike' },
  { src: '/images/logos/Asos.png', alt: 'ASOS' },
  { src: '/images/logos/adidas.png.webp', alt: 'adidas' },
  { src: '/images/logos/reebok.png.webp', alt: 'reebok' },
  { src: '/images/logos/amazon.png.webp', alt: 'amazon' },
  { src: '/images/logos/zara.png.webp', alt: 'Zara' },
  { src: '/images/logos/H&M.png', alt: 'H&M' },
  { src: '/images/logos/C&A.png', alt: 'C&A' },
  { src: '/images/logos/armaniexchange.gif.webp', alt: 'armaniexchange' },
  { src: '/images/logos/32degrees.png.webp', alt: '32degrees' },
  { src: '/images/logos/veepee-black.svg', alt: 'veepee' },
  { src: '/images/logos/carters.png.webp', alt: 'carters' },
  { src: '/images/logos/crocs.png.webp', alt: 'crocs' },
  { src: '/images/logos/levi.png.webp', alt: 'levis' },
  { src: '/images/logos/ralph%20lauren.gif', alt: 'ralph lauren' },
  { src: '/images/logos/uniqlo-logo.png', alt: 'uniqlo' },
  { src: '/images/logos/charlottetilbury.png.webp', alt: 'charlottetilbury' },
  { src: '/images/logos/gap.png.webp', alt: 'gap' },
  { src: '/images/logos/oldnavy.png.webp', alt: 'oldnavy' },
  { src: '/images/logos/6pm.png.webp', alt: '6pm' },
  { src: '/images/logos/disneystore.png.webp', alt: 'disneystore' },
  { src: '/images/logos/finishline.png.webp', alt: 'finishline' },
  { src: '/images/logos/logoCuraprox_20190528_40.png', alt: 'Curaprox' },
  { src: '/images/logos/joesnewbalanceoutlet.png.webp', alt: 'newbalance' },
  { src: '/images/logos/TChibo.png', alt: 'TChibo' },
  { src: '/images/logos/UNOde50.svg', alt: 'UNOde50' },
  { src: '/images/logos/sephora.png.webp', alt: 'sephora' },
  { src: '/images/logos/timberland.png.webp', alt: 'timberland' },
  { src: '/images/logos/puma.png.webp', alt: 'Puma' },
  { src: '/images/logos/gucci.JPG', alt: 'Gucci' },
];

const renderLogo = (logo, index) => (
  <img
    key={`${logo.src}-${index}`}
    src={process.env.PUBLIC_URL + logo.src}
    alt={logo.alt}
    loading="lazy"
    decoding="async"
  />
);

const ScrollSection = () => {
  return (
    <div className="scrollbody">
      <div className="scrollbox">
        <div className="scroll-container">
          <div className="scroll-content" id="scrollContent">
            {logos.map(renderLogo)}
          </div>
          <div className="scroll-content">
            {/* Дублированные логотипы для бесшовного эффекта */}
            {logos.map((logo, index) => renderLogo(logo, `duplicate-${index}`))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScrollSection;
